// src/components/FloatingNav.jsx
import { FaHome, FaReceipt, FaCashRegister, FaShoppingCart,FaCrown  } from "react-icons/fa";
import { Link, useLocation } from "react-router-dom";
import { GiChefToque, GiMeal, GiCook, GiKitchenKnives } from "react-icons/gi";
import { CgMoreO } from "react-icons/cg";


const FloatingNav = () => {
  const location = useLocation();

  const items = [
    { label: "Dashboard", icon: <FaHome />, to: "/restaurant/dashboard" },
     { label: "Receipt", icon: <FaReceipt />, to: "/restaurant/receipt" },
    { label: "Counter", icon: <FaCashRegister />, to: "/restaurant/counter" },
    { label: "Orders", icon: <FaShoppingCart />, to: "/restaurant/orders" },
    { label: "KOT", icon: <GiCook  />, to: "/restaurant/kot" },
    { label: "More", icon: <CgMoreO  />, to: "/restaurant/more" }
  ];

  return (
    <div className="hidden md:flex flex-col fixed top-1/2 -translate-y-1/2 right-4 z-50 space-y-4">
      {items.map((item) => (
        <Link
          key={item.to}
          to={item.to}
          className={`bg-rose-600 text-white p-3 rounded-full shadow-lg hover:bg-rose-700 transition-all duration-300 tooltip tooltip-left`}
          data-tip={item.label}
          title={item.label}
        >
          <span className={location.pathname === item.to ? "scale-110" : ""}>
            {item.icon}
          </span>
        </Link>
      ))}
    </div>
  );
};

export default FloatingNav;
